import { AgentIcon } from '../icons';
import { Badge } from '../Badge';
import { Button } from '../Button';
import { useCentre } from '../notifications/useNotifications.js';
import { compteBadge, libelleBoutonAgents } from './agentsModel.js';
import '../notifications/Notifications.css';

/**
 * Bouton « Agents » de l'en-tête (P1, contrat §11.1) : ouvre le centre des agents (en cours,
 * mes agents, abonnements, modèles). Pastille du nombre d'agents actifs, comme les non-lues
 * sur la cloche (useCompteAgents) : nom accessible complet (« Agents : 2 actifs »), pastille
 * masquée aux lecteurs d'écran. Absent sans contexte complet. Pas rendu sous 480 px
 * (Header.jsx, CENTRE_COMPACT_QUERY) : l'en-tête n'a plus la place, le tiroir de la cloche
 * porte alors l'onglet « Agents ».
 */
export function AgentsButton() {
  const { actif, tiroir, ouvrir, agentsActifs } = useCentre();
  if (!actif) return null;
  const label = libelleBoutonAgents(agentsActifs);
  return (
    <Button
      iconOnly
      icon={AgentIcon}
      iconSize={18}
      className="header-icon-button agents-button"
      data-centre="agents"
      aria-haspopup="dialog"
      aria-expanded={tiroir === 'agents'}
      aria-label={label}
      title={`${label} — vos veilles, abonnements et modèles`}
      onClick={(event) => ouvrir('agents', event.currentTarget)}
    >
      {agentsActifs > 0 && <Badge count={compteBadge(agentsActifs)} className="agents-button__count" aria-hidden="true" />}
    </Button>
  );
}
